export const volumes = [
  {
    number: "Volume I",
    title: "The Clinical Assessment Blueprint",
    subtitle: "Establish a Clear Starting Point Before Reviewing the Setup",
    intro:
      "Before evaluating the proposed movements, you need to understand the clinical situation you're working with. In this volume, I've organized a practical framework to help you structure your initial case assessment.",
    items: [
      "A structured initial assessment worksheet.",
      "A checklist for reviewing available diagnostic records.",
      "A framework for documenting the patient's treatment objectives.",
      "A clinical considerations map for identifying potential limitations.",
      "A preliminary case-review checklist.",
      "A worksheet for documenting questions that require further investigation.",
    ],
    objective:
      "Start each review with a clearer understanding of the case, its objectives, and the information that still needs to be evaluated.",
  },
  {
    number: "Volume II",
    title: "The Space Management Blueprint",
    subtitle: "Organize Your Assessment of Space Requirements and Treatment Alternatives",
    intro:
      "Space management involves more than identifying crowding. You also need to consider the clinical circumstances, treatment objectives, periodontal limitations, and potential consequences of different approaches.",
    items: [
      "A visual map of common space-management considerations.",
      "An IPR assessment worksheet.",
      "An expansion considerations checklist.",
      "A distalization review framework.",
      "A comparison matrix for organizing potential treatment alternatives.",
      "A clinical documentation template for recording the rationale behind your decisions.",
    ],
    objective:
      "Evaluate space-management questions through a more organized process instead of relying on an isolated decision or a single software recommendation.",
  },
  {
    number: "Volume III",
    title: "The Attachment Strategy Blueprint",
    subtitle: "Structure Your Review of Attachments and Planned Tooth Movements",
    intro:
      "Attachments are one component of clear aligner biomechanics, and their role must be considered in the context of the individual case. This blueprint provides a framework for organizing your review.",
    items: [
      "An attachment review worksheet.",
      "A visual reference organized by movement category.",
      "A checklist for examining attachment placement in the proposed setup.",
      "A matrix for documenting intended movements and related clinical questions.",
      "A review framework for identifying potential limitations.",
      "A communication worksheet for discussing attachment-related concerns.",
    ],
    objective:
      "Make your attachment review more systematic and improve the clarity of your clinical questions.",
  },
  {
    number: "Volume IV",
    title: "The Complex Case Blueprint",
    subtitle: "Organize Your Clinical Review When a Case Requires More Careful Assessment",
    intro:
      "Some cases require additional diagnostic information, more detailed planning, or collaboration with other professionals. I've structured this blueprint to help you organize the questions that arise.",
    items: [
      "A complex-case assessment worksheet.",
      "A framework for organizing Class II considerations.",
      "A framework for organizing Class III considerations.",
      "A crossbite review worksheet.",
      "A checklist for identifying potential treatment limitations.",
      "A case-discussion template for situations requiring additional expertise.",
    ],
    objective:
      "Bring greater structure to complex-case discussions and help you identify when further assessment or specialist input may be appropriate.",
  },
  {
    number: "Volume V",
    title: "The Biomechanics Review Blueprint",
    subtitle: "Evaluate Planned Movements With a More Structured Clinical Framework",
    intro:
      "Digital treatment simulations are useful planning tools, but their proposed movements still require appropriate clinical evaluation. This volume helps you organize your review of movement objectives.",
    items: [
      "A planned-movement review worksheet.",
      "A torque and root-control considerations map.",
      "A framework for documenting potential movement limitations.",
      "A checklist for reviewing the relationship between treatment objectives and the proposed setup.",
      "A clinical questions matrix for identifying areas requiring further investigation.",
      "A worksheet for documenting concerns before communicating with the planning team.",
    ],
    objective:
      "Review proposed movements in the context of your clinical assessment rather than treating the digital simulation as an automatic substitute for clinical judgment.",
  },
  {
    number: "Volume VI",
    title: "The Finalization Blueprint",
    subtitle: "Organize Your Review From Treatment Progress to Finishing",
    intro:
      "A well-organized treatment review doesn't end when the initial setup is approved. Treatment progress, aligner tracking, clinical findings, and the patient's response may require reassessment.",
    items: [
      "A treatment-progress review worksheet.",
      "A checklist for documenting potential tracking concerns.",
      "A framework for comparing planned objectives with observed clinical findings.",
      "A refinement-discussion worksheet.",
      "A finishing-stage review checklist.",
      "A case-closure documentation template.",
    ],
    objective:
      "Maintain a structured review process throughout treatment and document when reassessment or further intervention may be necessary.",
  },
];
